import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const deviceAssignmentReasonsConstants = {
    DEVICE_ASSIGNED_REASON_LOADED: 'DEVICE_ASSIGNED_REASON_LOADED',
    DEVICE_ASSIGNED_REASON_CREATED: 'DEVICE_ASSIGNED_REASON_CREATED',
    DEVICE_ASSIGNED_REASON_UPDATED: 'DEVICE_ASSIGNED_REASON_UPDATED',
    DEVICE_ASSIGNED_REASON_DELETED: 'DEVICE_ASSIGNED_REASON_DELETED'
};

export const deviceAssignmentReasonsFulfilledConstants = getActionTypesResult(deviceAssignmentReasonsConstants, '_FULFILLED');

export const deviceAssignmentReasonsRejectedConstants = getActionTypesResult(deviceAssignmentReasonsConstants, '_REJECTED');

export const deviceAssignmentReasonsPendingConstants = getActionTypesResult(deviceAssignmentReasonsConstants, '_PENDING');

export const fetchAssignmentReasons =
    createAsyncAction(deviceAssignmentReasonsConstants.DEVICE_ASSIGNED_REASON_LOADED, () =>
        api.get('deviceAssignmentReason').then(res => res.data)
    );

export const saveAssignmentReason = createAsyncAction(deviceAssignmentReasonsConstants.DEVICE_ASSIGNED_REASON_CREATED,
    assignmentReason =>
        api.post('deviceAssignmentReason', assignmentReason).then(res => res.data)
);

export const updateAssignmentReason = createAsyncAction(
    deviceAssignmentReasonsConstants.DEVICE_ASSIGNED_REASON_UPDATED,
    (assignmentReasonId, assignmentReason) =>
        api.put(`deviceAssignmentReason`, assignmentReason).then(res => res.data)
);

export const deleteAssignmentReason =
    createAsyncAction(deviceAssignmentReasonsConstants.DEVICE_ASSIGNED_REASON_DELETED,
        assignmentReason =>
            api.delete(`deviceAssignmentReason/${assignmentReason.id}`).then(() => assignmentReason.id)
    );
